export default __webpack_public_path__ + "static/media/geometry-artwork-8.17163990.jpg";